import React, { useState } from 'react'
import { makeStyles } from "@material-ui/core";
import * as sweetalert from "sweetalert";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../../navigation/Auth/auth";


export function useFormupdate(initialFValues, validateOnChange = false, validate) {

    const navigate = useNavigate();
    const auth = useAuth();
    const location = useLocation();
    const [values, setValues] = useState(initialFValues);
    const [errors, setErrors] = useState({});
    const redirectPath = location.state?.path || "/dashboard";
    const [loginInput, setLogin] = useState({
        price_for_general_distributor: "",
        price_for_special_distributor: "",
        price_for_client:"",
        price_form_special_distributor_to_general:"",
        price_form_special_distributor_to_special:"",
        price_form_special_distributor_to_client:"",
        price_form_general_distributor_to_special:"",
        price_form_general_distributor_to_general:"",
        price_form_general_distributor_to_client:"",
        price_form_client_to_client:"",
        price_form_client_to_special_distributor:"",
        price_form_client_to_general_distributor:"",
        discount_for_client:"",
        discount_for_special_distributor:"",
        discount_for_general_distributor:"",
        profit_for_client:"",
        profit_for_special_distributor:"",
        profit_for_general_distributor:"",
        profit_form_special_distributor_to_general:"",
        profit_form_special_distributor_to_special:"",
        profit_form_special_distributor_to_client:"",
        profit_form_general_distributor_to_special:"",
        profit_form_general_distributor_to_general:"",
        profit_form_general_distributor_to_client:"",
        profit_form_client_to_client:"",
        profit_form_client_to_special_distributor:"",
        profit_form_client_to_general_distributor:"",
      });
    const handleInputChange = e => {
        
        const { name, value } = e.target
      
        setLogin({ ...loginInput, [name]: value });
   
        if (validateOnChange)
            validate({ [name]: value })
            
    }

    const resetForm = () => {
        setValues(initialFValues);
        setErrors({})
    }



    const addForm = () => {
        if (validate()) {
           
          }
        
    }

    return {
        loginInput,
        setLogin,
        errors,
        setErrors,
        handleInputChange,
        addForm,
        resetForm

    }
  
}


const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiFormControl-root': {
            width: '80%',
            margin: theme.spacing(1)
        }
    }
}))

export function Form(props) {

    const classes = useStyles();
    const { children, ...other } = props;
    return (
        <form className={classes.root} autoComplete="off" {...other}>
            {props.children}
        </form>
    )
}

